import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PostUser from 'flarum/components/PostUser';
import Tooltip from 'flarum/common/components/Tooltip';

app.initializers.add('justoverclock/auto-post-badge-pro', () => {
  extend(PostUser.prototype, 'view', function (vnode) {
    const checkRoute = app.current.get('routeName');

    if (checkRoute === 'discussion' || checkRoute === 'discussion.near' || checkRoute === 'blogArticle') {
      const post = this.attrs.post;
      const userPosts = post.user()?.commentCount();
      const complColor = app.forum.attribute('justoverclock-auto-post-badge-pro.bgColor') || '#d7ffcc';
      const backgrTwo = app.forum.attribute('justoverclock-auto-post-badge-pro.bgColorTwo') || '#ffffff';

      if (!post.isHidden()) {
        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromOne') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toOne')
        ) {
          const tierOne = app.forum.attribute('justoverclock-auto-post-badge-pro.iconOne') || 'fas fa-baby' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromOne');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toOne');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPerc = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPerc}>
                  <i class={tierOne} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelOne') || 'The Baby'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromTwo') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toTwo')
        ) {
          const tierTwo = app.forum.attribute('justoverclock-auto-post-badge-pro.iconTwo') || 'fas fa-child' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromTwo');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toTwo');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercTwo = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercTwo}>
                  <i class={tierTwo} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelTwo') || 'The Baby'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromTree') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toTree')
        ) {
          const tierTree = app.forum.attribute('justoverclock-auto-post-badge-pro.iconTree') || 'fas fa-chalkboard-teacher' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromTree');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toTree');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercTree = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercTree}>
                  <i class={tierTree} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelTree') || 'The Teacher'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromFour') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toFour')
        ) {
          const tierFour = app.forum.attribute('justoverclock-auto-post-badge-pro.iconFour') || 'fas fa-flask' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromFour');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toFour');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercFour = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercFour}>
                  <i class={tierFour} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelFour') || 'The Expert'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromFive') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toFive')
        ) {
          const tierFive = app.forum.attribute('justoverclock-auto-post-badge-pro.iconFive') || 'fas fa-brain' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromFive');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toFive');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercFive = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercFive}>
                  <i class={tierFive} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelFive') || 'The Guru'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromSix') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toSix')
        ) {
          const tierSix = app.forum.attribute('justoverclock-auto-post-badge-pro.iconSix') || 'fab fa-optin-monster' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromSix');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toSix');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercSix = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercSix}>
                  <i class={tierSix} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelSix') || 'The Monster'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromSeven') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toSeven')
        ) {
          const tierSeven = app.forum.attribute('justoverclock-auto-post-badge-pro.iconSeven') || 'fas fa-fingerprint' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromSeven');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toSeven');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercSeven = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercSeven}>
                  <i class={tierSeven} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelSeven') || 'Untouchable'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromEight') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toEight')
        ) {
          const tierEight = app.forum.attribute('justoverclock-auto-post-badge-pro.iconEight') || 'fas fa-user-tag' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromEight');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toEight');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercEight = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercEight}>
                  <i class={tierEight} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelEight') || 'The Special One'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromNine') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toNine')
        ) {
          const tierNine = app.forum.attribute('justoverclock-auto-post-badge-pro.iconNine') || 'fas fa-medal' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromNine');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toNine');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercNine = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercNine}>
                  <i class={tierNine} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelNine') || 'The Legend'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromTen') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toTen')
        ) {
          const tierTen = app.forum.attribute('justoverclock-auto-post-badge-pro.iconTen') || 'fas fa-user-graduate' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromTen');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toTen');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercTen = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercTen}>
                  <i class={tierTen} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelTen') || 'The Guru'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromEleven') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toEleven')
        ) {
          const tierEleven = app.forum.attribute('justoverclock-auto-post-badge-pro.iconEleven') || 'fas fa-bible' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromEleven');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toEleven');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercEleven = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercEleven}>
                  <i class={tierEleven} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelEleven') || 'God'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromTwelve') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toTwelve')
        ) {
          const tierTwelve = app.forum.attribute('justoverclock-auto-post-badge-pro.iconTwelve') || 'fas fa-surprise' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromTwelve');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toTwelve');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercTwelve = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercTwelve}>
                  <i class={tierTwelve} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelTwelve') || 'Impressive!'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromThirteen') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toThirteen')
        ) {
          const tierThirteen = app.forum.attribute('justoverclock-auto-post-badge-pro.iconThirteen') || 'fas fa-shield-alt' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromThirteen');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toThirteen');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercThirteen = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercThirteen}>
                  <i class={tierThirteen} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelThirteen') || 'Unstoppable'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromFourteen') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toFourteen')
        ) {
          const tierFourteen = app.forum.attribute('justoverclock-auto-post-badge-pro.iconFourteen') || 'fab fa-pied-piper-alt' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromFourteen');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toFourteen');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercFourteen = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercFourteen}>
                  <i class={tierFourteen} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelFourteen') || 'WiseMan'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromFifteen') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toFifteen')
        ) {
          const tierFifteen = app.forum.attribute('justoverclock-auto-post-badge-pro.iconFifteen') || 'fas fa-code' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromFifteen');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toFifteen');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercFifteen = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercFifteen}>
                  <i class={tierFifteen} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelFifteen') || 'Hacker'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromSixteen') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toSixteen')
        ) {
          const tierSixteen = app.forum.attribute('justoverclock-auto-post-badge-pro.iconSixteen') || 'fas fa-laptop-code' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromSixteen');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toSixteen');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercSixteen = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercSixteen}>
                  <i class={tierSixteen} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelSixteen') || 'Coder'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromSeventeen') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toSeventeen')
        ) {
          const tierSeventeen = app.forum.attribute('justoverclock-auto-post-badge-pro.iconSeventeen') || 'fas fa-crosshairs' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromSeventeen');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toSeventeen');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercSeventeen = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercSeventeen}>
                  <i class={tierSeventeen} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelSeventeen') || 'General'}
                </span>
              </Tooltip>
            </span>
          );
        }

        if (
          userPosts >= app.forum.attribute('justoverclock-auto-post-badge-pro.fromEighteen') &&
          userPosts <= app.forum.attribute('justoverclock-auto-post-badge-pro.toEighteen')
        ) {
          const tierEighteen = app.forum.attribute('justoverclock-auto-post-badge-pro.iconEighteen') || 'fab fa-reddit-alien' + ' autopost';
          const lowerBound = app.forum.attribute('justoverclock-auto-post-badge-pro.fromEighteen');
          const upperBound = app.forum.attribute('justoverclock-auto-post-badge-pro.toEighteen');
          const nextBadge = userPosts - upperBound + 1;
          const resNextBadge = Math.abs(nextBadge);
          const perc = ((userPosts - lowerBound) / (upperBound - lowerBound)) * 100;
          let bgPercEighteen = `background: -webkit-linear-gradient(left, ${complColor} ${perc}%,${backgrTwo} ${perc}%) !important;`;
          vnode.children.push(
            <span>
              <Tooltip
                text={
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.nextBadge') +
                  ' ' +
                  resNextBadge +
                  ' ' +
                  app.translator.trans('justoverclock-auto-post-badge-pro.forum.posts')
                }
              >
                <span className="auto-badge" style={bgPercEighteen}>
                  <i class={tierEighteen} />
                  {app.forum.attribute('justoverclock-auto-post-badge-pro.labelEighteen') || 'Alien'}
                </span>
              </Tooltip>
            </span>
          );
        }
      }
    }
  });
});
